export default __webpack_public_path__ + "static/media/credit-card.e13e6426.svg";